import { html, utl_renderObjects, utl_fadeIn } from "../base/_utils";
import { newsStories } from "../data/_news-stories";
import { newsStoryCard } from "../components/templates/_news-story-card";

document.addEventListener("DOMContentLoaded", () => {
    const newsStoriesContainer = document.querySelector("#news-stories-container");
    const loadMoreBtn = document.querySelector(".load-more-btn");

    utl_renderObjects({
        data: newsStories,
        template: (story) => html`<div class="col-md-6 col-xl-4 story-col text-center mt-3 ${!story.latestStory ? "hidden" : ""}">${newsStoryCard(story)}</div>`,
        target: "#news-stories-container",
    });

    utl_fadeIn();

    newsStoriesContainer.classList.remove("min-vh-100");

    loadMoreBtn.addEventListener("click", () => {
        // Get all currently hidden items
        const hiddenItems = document.querySelectorAll(".hidden");

        // Reveal up to 6
        hiddenItems.forEach((item, index) => {
            if (index < 6) item.classList.remove("hidden");
        });

        // If last batch, hide the button
        if (hiddenItems.length <= 6) {
            loadMoreBtn.style.display = "none";
        }
    });
});
